import { Upload } from "antd";
import { jsx as _jsx } from "react/jsx-runtime";
var Dragger = Upload.Dragger;
export var UploadFileDragger = function UploadFileDragger(props) {
    var accept = props.accept, customRequest = props.customRequest, children = props.children;
    return /*#__PURE__*/ _jsx(Dragger, {
        accept: accept,
        customRequest: customRequest,
        children: children
    });
};
